// Copyright 2025 Sorama B.V.
import { bindable, customElement } from "aurelia-framework";

@customElement("waveform-loader")
export class WaveformLoader {
    // Public properties
    @bindable
    public visible = true;

    @bindable
    public size?: string; // Optional size override (e.g., "16px", "1.5em", "24px")

    @bindable
    public dark = false; // Dark variant for different backgrounds
}
